var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OptionServiceTypeDisplay } from '../models/enums';
import buildPlanDisplay from './buildPlanDisplay';
import addPlanNoUpgrade from './addPlanNoUpgrade';
import sendToSalesFunnel from './sendToSalesFunnel';
import { getKeyByValue, planSvgChecked } from './helperFunctions';
import AppState from '../AppState';
/**
 * Process available plans.
 *
 * @param {AvailableSelections} plan - The selected plan.
 * @param {AvailableSelections[]} allPlans - Array of plans available to this
 *                                           address.
 */
const processAvailablePlans = (plan, allPlans) => {
    const slabFibreServiceType = AppState.get('slabFibreServiceType');
    const addressConfirmed = AppState.get('addressConfirmed');
    const sfpModel = AppState.get('serviceFunnelPackage');
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, Window, context, settings } = drupalJsObjects;
    const { baseUrl } = settings;
    const servicePlans = context.querySelector('#service-plans');
    const greatNews = document.createElement('div');
    const updatedPlans = allPlans.map(item => {
        return addPlanNoUpgrade(item, plan);
    });
    let lineSpeedConfirmation = '';
    const serviceType = getKeyByValue(sfpModel.serviceType);
    if (['FTTN', 'FTTC', 'FTTB'].includes(serviceType)) {
        lineSpeedConfirmation = `<p class="great-news--text">${Drupal.t(`We can't confirm your line speeds until your service is activated on the iPrimus nbn™ network. If your iPrimus nbn™ connection doesn't allow you to properly benefit from the speed tier you're on, we'll provide you with your maximum line speed and alternative options. Already an iPrimus customer? Please call <a href="tel:131789">13 17 89</a>`)}</p>`;
    }
    greatNews.classList.add('great-news');
    greatNews.innerHTML = `
    <p class="great-news--title">${Drupal.t('Available plans at your address')}</p>
    <p class="great-news--text">${Drupal.t('Check out our available plans below and find the perfect fit for your needs.')}</p>
    ${lineSpeedConfirmation}
  `;
    servicePlans.appendChild(greatNews);
    const confirmationMessage = document.createElement('div');
    confirmationMessage.setAttribute('id', 'address-confirmation-5');
    confirmationMessage.style.display = 'block';
    confirmationMessage.classList.add('address-tile--confirmation', 'service-available--confirmation');
    if (OptionServiceTypeDisplay.hasOwnProperty(slabFibreServiceType)) {
        const displayText = OptionServiceTypeDisplay[slabFibreServiceType];
        confirmationMessage.innerHTML = `
      <p id="package-confirmation-message">Great! ${displayText} is available.</p>
    `;
        confirmationMessage.appendChild(addressConfirmed);
        servicePlans.appendChild(confirmationMessage);
    }
    const tryAnotherAddressLink = document.createElement('p');
    tryAnotherAddressLink.classList.add('service-plans--another-address');
    tryAnotherAddressLink.innerHTML = `<a id="another-address" href="#">Try another address?</a>`;
    tryAnotherAddressLink.querySelector('#another-address').onclick = () => location.reload();
    servicePlans.appendChild(tryAnotherAddressLink);
    (() => __awaiter(void 0, void 0, void 0, function* () {
        const sortedPlans = updatedPlans.sort((a, b) => a.price - b.price);
        for (const plan of sortedPlans) {
            const { PlanIdentifier, nodeData } = plan;
            const planData = yield nodeData;
            const badges = [];
            if (planData.data[0].attributes.field_plan_callout_text !== null) {
                badges.push(Drupal.t(planData.data[0].attributes.field_plan_callout_text));
            }
            buildPlanDisplay(PlanIdentifier, planData, badges, 0);
        }
        const defaultSelected = context.querySelector('#service-upgrades .service-plans--service-plan');
        defaultSelected.classList.add('selected');
        defaultSelected.querySelector('.plan-radio').innerHTML = planSvgChecked;
        context.querySelectorAll('#address-check-exit, #address-check-continue').forEach((button) => button.style.display = 'block');
        context.querySelector('#address-check-exit').onclick = (event) => {
            event.preventDefault();
            Window.location.href = `${baseUrl}/nbn-plans`;
        };
        // Send select plan data to Sales Funnel.
        context.querySelector('#address-check-continue').onclick = (event) => {
            event.preventDefault();
            const selectedPlan = context.querySelector('.service-plans--service-plan.selected');
            const selectPlanId = selectedPlan.getAttribute('data-plan-identifier');
            sendToSalesFunnel(selectPlanId, sortedPlans);
        };
    }))();
};
export default processAvailablePlans;
